import { writable } from 'svelte/store';
import { ajaxRequestor, getApiHost } from '../../../utils/index.js';
import { productsEndpoint, krogerTokenEndpoint, krogerRefreshEndpoint, 
// targetAuthEndpoint,
krogerCartEndpoint } from '../data/index.js';
import { AuthStatus } from '../enum/index.js';
const state = {
    //TODO: PROBABLY UNNECESSARY:
    endpoint: productsEndpoint,
    initialized: false,
    referenceId: crypto.randomUUID()
};
const baseResponse = {
    status: AuthStatus.WAITING,
    refreshToken: '',
    expiresIn: 0,
    accessToken: '',
    tokenType: '',
    valid: false
};
const errorResponse = {
    ...baseResponse,
    status: AuthStatus.ERROR
};
const store = writable(state);
const getReferenceId = () => state.referenceId;
const fetchAccessToken = async () => {
    try {
        const request = new Request(`${getApiHost()}${krogerTokenEndpoint}?id=${state.referenceId}`);
        const response = await fetch(request);
        return handleKrogerApiResponse(response);
    }
    catch (err) {
        console.error('MERCURY AUTH ', err);
        return errorResponse;
    }
};
const refreshAccessToken = async (token) => {
    try {
        const request = new Request(`${krogerRefreshEndpoint}?token=${token.refreshToken}`);
        const response = await fetch(request);
        return handleKrogerApiResponse(response);
    }
    catch (err) {
        console.error('[MERCURY AUTH] ', err);
        return errorResponse;
    }
};
/**
 * Creates a fetch Header and sets to what we need
 * @param token Auth token
 */
const getRequestConfig = (token) => {
    const headers = new Headers();
    headers.set('Authorization', `bearer ${token.accessToken}`);
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return headers;
};
/**
 * `createCart` (at time of writing) appears to only be used for creating Kroger checkout carts.
 * If we need to support other retailer checkout carts using this method, we may want to refactor it to accept a `retailer` parameter to support different endpoints/payloads.
 * @param token
 * @param items
 * @returns
 */
const createCart = async (token, items) => {
    try {
        const data = { items, token: token.accessToken };
        const options = {
            headers: getRequestConfig(token),
            body: JSON.stringify(data)
        };
        const response = await ajaxRequestor.post(krogerCartEndpoint, options, true);
        if (response && response.status === 204) {
            return [true, null];
        }
        else {
            throw Error;
        }
    }
    catch (err) {
        return [false, err];
    }
};
const handleKrogerApiResponse = async (response) => {
    if (response.ok) {
        const key = 'auth-kro';
        const data = await response.json();
        const resp = {
            ...baseResponse,
            status: AuthStatus.SUCCESS,
            valid: true,
            ...data
        };
        localStorage.setItem(key, JSON.stringify(resp));
        return resp;
    }
    const status = response.status === 404 ? AuthStatus.WAITING : AuthStatus.ERROR;
    return {
        ...baseResponse,
        status
    };
};
const getCurrentAccessToken = () => {
    const lsToken = localStorage.getItem(`auth-kro`);
    if (!lsToken) {
        return {
            refreshToken: '',
            expiresIn: 0,
            accessToken: '',
            tokenType: '',
            valid: false
        };
    }
    return JSON.parse(lsToken);
};
const clearToken = () => {
    const key = `auth-kro`;
    localStorage.removeItem(key);
};
export default {
    subscribe: store.subscribe,
    set: store.set,
    update: store.update,
    refreshAccessToken,
    fetchAccessToken,
    getCurrentAccessToken,
    clearToken,
    getReferenceId,
    createCart
};
